<template>
<div>

    <p>Detail the plan and tier options below with the <b>total monthly cost</b>.</p>

    <table class="table pt-4">
        <tbody>
        <tr>
            <th>Age</th>
            <th>Total Cost</th>
            <th>Employee Cost</th>
            <th>Employer Cost</th>
        </tr>

        <tr v-for="band in formData.bands">
            <td>{{ band.agePretty }}</td>
            <td><form-input label="" v-model="formData.bands[band.age].total_cost" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employeeCosts[band.age]" type="currency" /></td>
            <td><form-input label="" :disabled="true" :model-value="employerCosts[band.age]" type="currency" /></td>
        </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/Form'

function formatAsCurrency(val) {
    val = ('' + val).trim()

    val = (1 * val).toFixed(2)
    if (val.split('.').length < 2) {
        val = val + '.00'
    }
    if (val.split('.')[1].length < 2) {
        val = val + '0'
    }
    if (val[0] == '.') {
        val = '0' + val
    }
    return val
}

const MIN_AGE = 14
const MAX_AGE = 64

export default {
    props: ['initialValue', 'employeeCostCovered', ],
    mixins: [FormMixin],
    computed: {
        employerCosts() {
            const result = {}

            for (let i = MIN_AGE; i <= MAX_AGE; i++) {
                const totalCost = this.formData.bands[i].total_cost ? this.formData.bands[i].total_cost : 0
                result[i] = formatAsCurrency(totalCost * this.employeeCostCovered / 100)
            }

            return result
        },
        employeeCosts() {
            const result = {}

            for (let i = MIN_AGE; i <= MAX_AGE; i++) {
                const totalCost = this.formData.bands[i].total_cost ? this.formData.bands[i].total_cost : 0
                result[i] = formatAsCurrency(totalCost - this.employerCosts[i])
            }

            return result
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
            errors: {},
        }
    },
    methods: {
        getFormData() {
            const result = {}
            Object.values(this.formData.bands).forEach(b => {
                result[b.age] = b.total_cost
            })

            return result
        },
        makeFormData() {
            const bands = {}

            for (let i = MIN_AGE; i <= MAX_AGE; i++) {
                bands[i] = {
                    age: i,
                    agePretty: (i == MAX_AGE) ? i + '+' : i,
                    total_cost: this.initialValue[i] || '',
                }
            }

            return {
                bands: bands,
            }
        },
    },
}
</script>
